import React, { useContext, useState, useRef } from 'react';
import { withStyles } from '@material-ui/core';
import DataContext from '../data/DataContext';
// import BackIcon from "../../asset/img/btn_navi_up_material_nor.png";
// import BackIconPressed from "../../asset/img/btn_navi_up_material_pre.png";
// import HelpIcon from "../../asset/img/btn_action_help_material_nor.png";
// import HelpIconPressed from "../../asset/img/btn_action_help_material_pre.png";
// import HelpIconDisabled from "../../asset/img/btn_action_help_material_dis.png";

import ButtonClose from '../../asset/img/header_ico_close.svg';
import ButtonHome from '../../asset/img/header_ico_home.svg';

// import InputContext from "../data/InputContext";
import { uploadHistoryHtmlFileToS3 } from '../util/utilAWS';
import { closeChatbot } from '../util/utilNative';

const styles = (theme) => ({
  root: {
    width: '100%',
    height: '2.875rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // boxShadow: "1px 1px " + theme.color.lightGrey,
    zIndex: 11,
    position: 'fixed',
    top: '0px',
    // padding: "4px 16px 5px",
    backgroundColor: '#fff',
  },
  titleBox: {
    width: 'auto 15.25rem',
    // height: "21px",
    margin: '0 0 0 1rem',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    width: '100%',
    fontSize: theme.font.size15,
    fontWeight: 'bold',
    margin: '0.25rem 0 0 0',
    textAlign: 'left',
    color: '#000',
  },
  titleConnBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // justifyContent: "center"
    // margin: "0 0 5px 0"
  },
  titleStatusBox: {
    display: 'flex',
    minHeight: '1rem',
    alignItems: 'center',
  },
  titleConn: {
    width: '0.4375rem',
    height: '0.4375rem',
    margin: '0 0.25rem 0 0',
    backgroundColor: '#3fca1f',
    borderRadius: '50%',
  },
  titleConnEndChat: {
    width: '0.4375rem',
    height: '0.4375rem',
    margin: '0 0.25rem 0 0',
    backgroundColor: '#ea1917', //"#da0f47",
    borderRadius: '50%',
  },
  titleConnStr: {
    display: 'flex',
    fontSize: theme.font.size11,
    color: '#666',
    lineHeight: 'initial',
  },

  buttonBox: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },

  button: {
    width: '1.5rem',
    height: '1.5rem',
    backgroundSize: '1.5rem',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundColor: 'transparent',
    textIndent: '-9999em',
    border: 'none',
    // outline: "0 none",
    cursor: 'pointer',
  },
  buttonHome: {
    margin: '0.6875rem 1rem 0.6875rem 0',
    backgroundImage: `url(${ButtonHome})`,
  },
  buttonClose: {
    margin: '0.6875rem 1rem 0.6875rem 0',
    backgroundImage: `url(${ButtonClose})`,
  },

  /*
  help: {
    backgroundImage: `url(${HelpIcon})`,
    "&:active": {
      backgroundImage: `url(${HelpIconPressed})`,
    },
  },
  helpDisabled: {
    backgroundImage: `url(${HelpIconDisabled})`,
  },
  close: {
    color: theme.color.grey,
    minWidth: "40px",
  },
  
  rightButtonGroup: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  back: {
    backgroundImage: `url(${BackIcon})`,
    "&:active": {
      backgroundImage: `url(${BackIconPressed})`,
    },
  },
  */
});

function Header(props) {
  const { classes } = props;
  const context = useContext(DataContext);
  const [isClosed, setIsClosed] = useState(false);

  // const [hiddenClick, setHiddenClick] = useState(0);
  // const [helpEnabled, setHelpEnabled] = useState(true);

  // const handleHelp = () => {
  //   setHelpEnabled(false);
  //   setTimeout(() => {
  //     setHelpEnabled(true);
  //   }, 1000);

  //   context.request(context, context.string.chat.help, "button");
  // };

  const handleRestart = async () => {
    context.request(context, context.string.chat.restartConversation, 'button');
  };

  const handleClose = async () => {
    const mine = context.conversations.filter((c) => c.mine);
    if (mine.length > 2 && isClosed === false) {
      const rootChild = document.getElementById('root');
      const focusableElements = rootChild.querySelectorAll('*');

      context.setOpenCustomerFeedback(true);

      for (let i = 0; i < focusableElements.length; i++) {
        focusableElements[i].setAttribute('aria-hidden', 'true');
      }

      context.setOnCloseCustomerFeedback(() => {
        close(true);
      });
    } else {
      const rootChild = document.getElementById('root');
      const focusableElements = rootChild.querySelectorAll('*');

      for (let i = 0; i < focusableElements.length; i++) {
        focusableElements[i].removeAttribute('aria-hidden');
      }
      close();
    }
    setIsClosed(true);
  };

  const close = (force = false) => {
    setTimeout(async () => {
      console.log('end conversation');
      context.endConversation();

      if (context.isUserAction) {
        const htmlText = document.documentElement.innerHTML;
        try {
          const s3Res = await uploadHistoryHtmlFileToS3(
            context.sessionId,
            context.stage,
            context.countryCode,
            htmlText
          );
          console.log('[handleClose] S3 Upload Success', 's3Res:', s3Res);
        } catch (err) {
          console.log('[handleClose] S3 Upload Fail', 's3Res:', err);
        }
      }

      // ThinQ 앱 인터페이스가 있는 경우
      if (window.NativeInterface) {
        // 대화 내용이 있는 경우만 종료 팝업 호출
        if (context.isUserAction && window.NativeInterface) {
          if (force) {
            window.NativeInterface.closeView();
          } else {
            window.NativeInterface.closeViewWithPopup();
          }
        }
        // 대화 내용이 없는 경우 일반 종료
        else {
          window.NativeInterface.closeView && window.NativeInterface.closeView();
        }
      } else if (context.userAgent.isLGEAPP) {
        closeChatbot(context);
      } else if (context.channel === 'lg_pc') {
        // window.external.ConnAppx("d");
        console.log("[lg_pc] postMessage('ConnAppx_d')");
        window.chrome.webview.postMessage('ConnAppx_d');
      } else {
        window.close();
      }
    }, 300);
  };

  // const handleHidden = () => {
  //   if (context.stage !== "op") {
  //     if (hiddenClick >= 4) {
  //       context.addTXMessage(
  //         false,
  //         {
  //           Stage: context.stage,
  //           SessionID: context.sessionId,
  //           "Loading Bar":
  //             (window.endLoading - window.startLoading) / 1000 + " s",
  //           "Start Loading":
  //             (window.completeLoading - window.endLoading) / 1000 + " s",
  //           "Total Loading":
  //             (window.completeLoading - window.startLoading) / 1000 + " s",
  //           Nickname: context.channelParams.nickname,
  //         },
  //         true
  //       );
  //       setHiddenClick(0);
  //     } else {
  //       setHiddenClick(hiddenClick + 1);
  //     }
  //   }
  // };
  const chattingStatusStr = context.conversationEnd
    ? context.string.chat.chatEnd
    : context.chattingStatus;

  return (
    <>
      <div className={classes.root}>
        <div className={classes.titleBox}>
          <div className={classes.title}>LG전자 상담 챗봇</div>
          {chattingStatusStr && (
            <div className={classes.titleConnBox}>
              <div className={classes.titleStatusBox}>
                <>
                  <div
                    className={
                      !context.conversationEnd
                        ? classes.titleConn
                        : classes.titleConnEndChat
                    }
                  ></div>
                  <div className={classes.titleConnStr}>
                    {chattingStatusStr || '상담중'}
                  </div>
                </>
              </div>
            </div>
          )}
        </div>
        <div className={classes.buttonBox}>
          <button
            aria-label="챗봇 처음으로 이동"
            onClick={handleRestart}
            disabled={context.conversationEnd}
            className={[classes.button, classes.buttonHome].join(' ')}
          ></button>
          <button
            aria-label="챗봇 닫기"
            onClick={handleClose}
            className={[classes.button, classes.buttonClose].join(' ')}
          ></button>
        </div>
      </div>
    </>
  );

  // return (
  //   <>
  //     <div className={classes.root}>
  //       <div className={classes.titleBox}>
  //         <div className={classes.title}>LG전자 상담 챗봇</div>
  //         <div>
  //           <div className={classes.titleConn}></div>
  //           <span>상담중</span>
  //         </div>
  //       </div>
  //       <button
  //         type="button"
  //         className={[classes.button, classes.back].join(" ")}
  //         onClick={handleClose}
  //         aria-label={context.string.aria.header.exitButton}
  //       />
  //       {/*
  //       <span>
  //         <Button
  //           disableRipple={true}
  //           className={classes.button}
  //           onClick={handleMenu}
  //         >
  //           <MenuIcon />
  //         </Button>
  //       </span>
  //       */}
  //       <div
  //         className={classes.title}
  //         aria-label={context.string.aria.header.title}
  //         onClick={handleHidden}
  //         tabIndex={0}
  //         role={"text"}
  //       >
  //         {context.string.title}
  //       </div>
  //       <div className={classes.rightButtonGroup}>
  //         <button
  //           type="button"
  //           disabled={
  //             context.conversationEnd ||
  //             !context.conversationStart ||
  //             !helpEnabled
  //           }
  //           className={[
  //             classes.button,
  //             context.conversationEnd ||
  //             !context.conversationStart ||
  //             !helpEnabled
  //               ? classes.helpDisabled
  //               : classes.help,
  //           ].join(" ")}
  //           onClick={handleHelp}
  //           aria-label={context.string.aria.header.helpButton}
  //         />
  //         {/* <span>
  //           <Button
  //             disableRipple={true}
  //             className={[classes.button, classes.close].join(" ")}
  //             onClick={handleClose}
  //             aria-label={context.string.aria.header.exitButton}
  //           >
  //             <CloseIcon/>
  //           </Button>
  //         </span> */}
  //       </div>
  //     </div>
  //     {/* <Menu menuOpen={menuOpen} /> */}
  //   </>
  // );
}
export default withStyles(styles)(Header);
